import React from 'react';
import { Tree, Spin } from 'antd';
import axios from '../../../utils/AxiosUtil';
const { useState, useEffect } = React;



const Demo = (props) => {
    const initTreeData = [];
    const [treeData, setTreeData] = useState([]);
    const [ckdKeys, setCkdKeys] = useState([]);

    useEffect(async () => {
        let data = await axios.post('/fund/area/list-branch-and-leaf', { uid: props.uid ? props.uid : null })
        let provinceList = data ?.data ?.data ?.nodeList;
        let defaultCheckedKeys = data ?.data ?.data ?.defaultCheckedKeys;

        console.log('defaultCheckedKeys:', defaultCheckedKeys);
        if (defaultCheckedKeys && defaultCheckedKeys ?.length) {
            props.setDefaultCheckedArea(defaultCheckedKeys);
        }

        // console.log("init list branch and leaf data is:", provinceList);

        let newCheckedKeys = [];
        provinceList ?.forEach((p, i) => {
            let { title, key, province, city, isLeaf, checkable, checked } = p;
            initTreeData.push({
                title,
                key,
                province,
                city,
                isLeaf: isLeaf == 'true',
                checkable: checkable == 'true',
            })
            if (checked) {
                newCheckedKeys.push(key);
            }
        })
        console.log("initTreeData is:", initTreeData);
        setTreeData(initTreeData);

        setCkdKeys([...ckdKeys, ...newCheckedKeys]);
        if (defaultCheckedKeys) {
            // console.log("defaultCheckedKeys:", defaultCheckedKeys);
            setCkdKeys([...ckdKeys, ...defaultCheckedKeys]);
        }

    }, [])




    const onLoadData = ({ key, children, isLeaf, province, city, ...restProps }) => {
        // console.log('-------------------------onLoadData--' + key + '--------------------------', { key, children, isLeaf, province, city, ...restProps });
        return new Promise((resolve) => {
            if (children) {
                //此分支不进行异步加载
                // console.log("ONLOADDATA HAS CHILDREN");
                resolve();
                return;
            }
            let { pos } = { ...restProps };

            axios.post('/fund/area/list-branch-and-leaf', { province, city, pos }).then(data => {
                let children = data ?.data ?.data ?.nodeList;
                children.map((c, i) => {
                    c.isLeaf = c.isLeaf == 'true' ? true : false;
                    c.checkable = c.checkable == 'true' ? true : false;
                })

                setTreeData((origin) =>
                    updateTreeData(origin, key, children),
                );
                // console.log('>>>tree data:', treeData)
                resolve();
            }).catch(e => {
                // console.log('list-branch-and-leaf error:', e);
            })

        });

    }

    /**
     * 
     * @param {*} list 原treeData数组
     * @param {*} key 父节点的key
     * @param {*} children 新挂载的子节点数组
     */
    function updateTreeData(list, key, children) {
        // console.log("***updateTreeData list:", list);
        // console.log("***updateTreeData key children:", key, children);

        return list.map((node) => {
            if (node.key === key) {
                let a = { ...node, children };
                //为当前父node挂载子节点{...，children:children}
                // console.log('>>>>>{ ...node, children }', { ...node, children });
                return { ...node, children };
            }

            if (node.children) {
                //若node数据结构有children，递归更新children挂载
                // console.log('updateTreeData:', node);
                // console.log(" has node.children~~~~~", node.children);
                return { ...node, children: updateTreeData(node.children, key, children) };
            }

            return node;
        });
    }

    // 用户关联地区树
    return <Tree
        loadData={onLoadData}
        treeData={treeData}
        checkable
        showLine
        checkedKeys={ckdKeys}
        onCheck={
            (checkedKeys, event) => {
                let ckdKeysSet = new Set(ckdKeys);//获取点击前已勾选的所有节点信息；
                let { node, checked } = event;
                let { key } = node;//被点击节点对应地区信息 e.g'山东-72'
                if (!checked) {
                    //取消勾选，删除
                    ckdKeysSet.delete(key);
                } else {
                    //勾选，新增
                    ckdKeysSet.add(key)
                }
                let ckArr = Array.from(ckdKeysSet);

                setCkdKeys(ckArr);
                props.handleCheck(ckArr, event);
            }
        }

    />;
};

export default Demo;